export function HeaderProgress() {
	return (
		<div className="animate-in fade-in absolute inset-x-0 -bottom-1 w-full overflow-hidden">
			<div className="animate-bounce-x from-secondary/0 via-primary to-secondary/0 relative -bottom-px h-1 bg-gradient-to-r" />
		</div>
	);
}
